import { z } from "zod";

import { buildNamespace } from "@smart/itops-types-basic";

import { system } from "./base";
import { FormNS } from "./form";

export const FormVersionNS = buildNamespace({
  system,
  entity: "FormVersion",
} as const);

export const FormVersionSchema = z.object({
  uri: FormVersionNS.schema,
  operationId: z.string(),

  formUri: FormNS.schema,
  snapshotHash: z.string(),

  createdAt: z.string(),
  updatedAt: z.string(),
});

export type FormVersion = z.infer<typeof FormVersionSchema>;
